module.exports = __webpack_public_path__ + "static/media/bateau_bouee.617013bd.png";